export default __webpack_public_path__ + "static/media/RubyPokeball.30fb501a.svg";